import Observer from './Observer';

var Observable = (function() {

    Observable = function() {

        this.observersList = [];

        this.addObserver = function(observer) {
            if (!observer instanceof Observer) {
                throw new Error('Try to add not Observer object');
            }
            this.observersList.push(observer);
        }

        this.notifyObservers = function() {
            this.observersList.forEach(function(observer) {
                observer.handle();
            });
        }
    }

    return Observable;
})();

export default Observable;